(() => {
  const initStickyBuy = () => {
    const bar = document.querySelector('[data-pm-sticky-buy]');
    if (!bar) return;
    const triggerId = bar.querySelector('[data-pm-sticky-trigger]')?.dataset.pmStickyTrigger;
    const primary = triggerId ? document.getElementById(triggerId) : null;
    const stickyButton = bar.querySelector('[data-pm-sticky-trigger]');
    if (!primary || !stickyButton) return;

    const sync = () => {
      stickyButton.disabled = primary.disabled;
      stickyButton.textContent = primary.disabled ? 'SOLD OUT' : 'GET ACCESS';
    };
    sync();

    stickyButton.addEventListener('click', () => {
      sync();
      if (primary.disabled) {
        primary.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      primary.click();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          bar.hidden = entry.isIntersecting;
        } else {
          bar.hidden = true;
        }
      }, { threshold: 0.1 });
      observer.observe(primary);
    } else if (window.matchMedia('(max-width: 749px)').matches) {
      bar.hidden = false;
    }

    document.addEventListener('change', () => setTimeout(sync, 80));
  };

  const initReviewLinks = () => {
    const reviews = document.getElementById('judgeme_product_reviews');
    if (!reviews) return;

    document.querySelectorAll('.rating-wrapper').forEach((rating) => {
      if (rating.dataset.pmReviewLink === 'true') return;

      rating.dataset.pmReviewLink = 'true';
      rating.setAttribute('role', 'link');
      rating.setAttribute('tabindex', '0');
      rating.setAttribute('aria-label', 'Read customer reviews');
      rating.style.cursor = 'pointer';

      const goToReviews = () => {
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#judgeme_product_reviews');
        }
      };

      rating.addEventListener('click', goToReviews);
      rating.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          goToReviews();
        }
      });
    });
  };

  const init = () => {
    initStickyBuy();
    initReviewLinks();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
